import { Component} from '@angular/core';
import {MatTabsModule} from '@angular/material/tabs';
import { CrcConsultsPhoneComponent } from "./crc-consults-phone/crc-consults-phone.component";
import { CrcConsultEmailComponent } from "./crc-consult-email/crc-consult-email.component";
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';

@Component({
  selector: 'app-crc-consult-components',
  standalone: true,
  imports: [
    MatTabsModule,
    CrcConsultsPhoneComponent,
    CrcConsultEmailComponent,
    CommonModule,
    PageHeaderComponent
],
  templateUrl: './crc-consult-components.component.html',
  styleUrl: './crc-consult-components.component.css'
})
export class CrcConsultComponentsComponent {

  activeTab = 'phone'

  setActiveTab(tab : string){
    this.activeTab = tab;
  }
}
